import { create } from "zustand"

export const passwordChangeStore = create((set) => ({
  verifiedPassword: "",
  setVerifiedPassword: (verifiedPassword) => set({ verifiedPassword }),
  reset: () => set({ verifiedPassword: "" })
}))
